import GeneticCounsellor from "./GeneticCounsellor";

export default GeneticCounsellor